import { Link, Typography } from "@mui/material";

const AuthAgreementLabel = () => (
  <Typography
    component='span'
    variant='body14rg'
    sx={{ color: "text.primary" }}>
    Отправляя форму, я даю{" "}
    <Link
      href='https://disk.yandex.ru/i/WejnKwPQalJGKw'
      target='_blank'
      rel='noreferrer'>
      согласие на обработку данных
    </Link>{" "}
    и принимаю{" "}
    <Link
      href='https://disk.yandex.ru/i/dqQXePdOmagPKA'
      target='_blank'
      rel='noreferrer'>
      пользовательское соглашение
    </Link>
    .
  </Typography>
);

export default AuthAgreementLabel;
